import React from 'react';

const HumanIcon = ({ style = {}, width = '100', color = 'rgb(0,100,255)', viewBox = '0 0 100 100' }) => {
  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g fill="none" strokeLinejoin="round" strokeLinecap="round">
        <g strokeWidth="15" stroke="white">
          <circle cx="50" cy="12" r="12" stroke="none" fill="white" />
          <polyline points="20,55 42,31 42,63 35,92" />
          <polyline points="80,55 58,31 58,63 65,92" />
          <rect x="42" y="31" width="16" height="30" fill="white" />
        </g>
        <g strokeWidth="7" stroke={color}>
          <circle cx="50" cy="12" r="8" stroke="none" fill={color} />
          <polyline points="20,55 42,31 42,63 35,92" />
          <polyline points="80,55 58,31 58,63 65,92" />
          <rect x="42" y="31" width="16" height="30" fill={color} />
        </g>
      </g>
    </svg>
  );
};

export default HumanIcon;
